import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { 
  Plus, X, Search, Bell, ShoppingBag, Lock, LogOut, Store
} from 'lucide-react';

const POSActionBar = ({
  isPopup,
  selectedRestaurant,
  orderNumber,
  onlineOrderCount = 0,
  searchQuery,
  setSearchQuery,
  onNewOrder,
  onCancelOrder,
  onOpenOnlineOrders,
  onLock,
  onLogout,
  onChangeRestaurant
}) => {
  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-white border-b shadow-sm">
      {/* Logo and Brand */}
      <div className="flex items-center gap-2">
        <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center shadow">
          <Store className="h-5 w-5 text-white" />
        </div>
        <span className="font-bold text-xl text-red-600" style={{ fontFamily: 'Manrope' }}>
          {selectedRestaurant?.name || 'POS'}
        </span>
      </div>

      {/* Order Number */}
      <div className="flex items-center gap-2 ml-4">
        <span className="text-gray-600 font-medium">Order No.-</span>
        <span className="font-bold text-gray-800">{orderNumber || '----'}</span>
      </div>

      {/* New Order Button */}
      <Button 
        onClick={onNewOrder}
        className="bg-green-500 hover:bg-green-600 text-white font-semibold px-4"
        data-testid="pos-new-order-btn"
      >
        NEW ORDER
      </Button>

      {/* Search Bar - Center */}
      <div className="flex-1 max-w-md mx-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input 
            placeholder="Search item" 
            value={searchQuery} 
            onChange={(e) => setSearchQuery(e.target.value)} 
            className="pl-10 bg-gray-50 border-gray-200 focus:border-red-400" 
            data-testid="menu-search-input"
          />
        </div>
      </div>

      {/* Right Side Actions */}
      <div className="flex items-center gap-2 ml-auto">
        {/* Online Orders */}
        <Button 
          variant="outline"
          onClick={onOpenOnlineOrders}
          className="relative bg-red-500 hover:bg-red-600 text-white border-none"
          data-testid="pos-online-orders-btn"
        >
          <ShoppingBag className="h-4 w-4 mr-2" />
          ONLINE ORDER
          {onlineOrderCount > 0 && (
            <Badge className="absolute -top-2 -right-2 h-5 w-5 p-0 flex items-center justify-center bg-yellow-400 text-black text-xs">
              {onlineOrderCount}
            </Badge>
          )}
        </Button>

        {/* Cancel Button */}
        <Button 
          variant="outline"
          onClick={onCancelOrder}
          className="bg-gray-800 hover:bg-gray-900 text-white border-none"
          data-testid="pos-cancel-btn"
        >
          CANCEL
        </Button>

        {/* Notifications */}
        <Button 
          variant="ghost" 
          size="icon"
          className="relative"
          data-testid="pos-notifications-btn"
        >
          <Bell className="h-5 w-5 text-gray-600" />
          <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center bg-red-500 text-white text-xs">
            5
          </Badge>
        </Button>

        {/* Lock */}
        <Button 
          variant="ghost" 
          size="icon"
          onClick={onLock}
          data-testid="pos-lock-btn"
        >
          <Lock className="h-5 w-5 text-gray-600" />
        </Button>

        {/* Logout */}
        {isPopup && onLogout && (
          <Button 
            variant="ghost" 
            size="icon"
            onClick={onLogout}
            data-testid="pos-logout-btn"
          >
            <LogOut className="h-5 w-5 text-gray-600" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default POSActionBar;
